const _ = "_button_8xdxl_1", l = "_tooltip_8xdxl_14", o = "_clicked_8xdxl_44", t = "_arrow_8xdxl_48", x = "_close_8xdxl_56", c = "_isOver_8xdxl_75", d = "_yellow_8xdxl_83", e = "_white_8xdxl_86", s = "_md_8xdxl_89", n = "_lg_8xdxl_97", i = {
  button: _,
  tooltip: l,
  "fade-in": "_fade-in_8xdxl_1",
  clicked: o,
  arrow: t,
  close: x,
  isOver: c,
  yellow: d,
  white: e,
  md: s,
  lg: n
};
export {
  t as arrow,
  _ as button,
  o as clicked,
  x as close,
  i as default,
  c as isOver,
  n as lg,
  s as md,
  l as tooltip,
  e as white,
  d as yellow
};
//# sourceMappingURL=tooltip.module.less.js.map
